import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'jbm-filter-reset',
  templateUrl: './JBMFilterReset.component.html',
  styleUrls: ['./JBMFilterReset.component.scss'],
  host: {'class': 'JBMButton'}
})
export class JBMFilterResetComponent {
  @Input() class: string='light'
  @Output() onReset = new EventEmitter()
  @Input() disabled: boolean=false

  resetFilter() {
    this.onReset.emit();
  }
}
